import LoaderInline from '@jetbrains/ring-ui/components/loader-inline/loader-inline'
import * as React from 'react'

import {stringifyId} from '../../../../../../types'
import type {BuildId} from '../../../../../../types'
import {base_uri} from '../../../../../../types/BS_types'
import ContentPanel from '../../../../../common/ContentPanel/ContentPanel'
import IframeAdapter from '../../../../../common/IframeAdapter/IframeAdapter'
import type {BuildSnippet as BuildSnippetType} from '../BuildSnippets.types'

type Props = {
  snippet: BuildSnippetType
  buildId: BuildId
  className?: string
}

const getSnippetLink = (buildId: BuildId, snippetId: string): string =>
  `${base_uri}/app/placeId?buildId=${stringifyId(buildId)}&snippetId=${snippetId}&iframe=true`

function BuildSnippet({buildId, snippet, className}: Props) {
  const [isReady, setIsReady] = React.useState(false)
  const onIframeLoaded = React.useCallback(() => setIsReady(true), [setIsReady])
  const onURLChange = React.useCallback((newURL: string) => (window.location.href = newURL), [])
  return (
    <ContentPanel
      className={className}
      panelType={`expand${snippet.name}`}
      heading={snippet.name}
      headerSnippet={
        !isReady ? (
          <span>
            <LoaderInline />
          </span>
        ) : null
      }
      content={
        <IframeAdapter
          autoHeight
          key={stringifyId(buildId)}
          title={snippet.name}
          onIframeLoaded={onIframeLoaded}
          onURLChange={onURLChange}
          src={getSnippetLink(buildId, snippet.id)}
          data-resize={'enabled'}
          preventFlashing
        />
      }
    />
  )
}

export default React.memo<Props>(BuildSnippet)
